const messages = {
  title: "Veikals",
  description: "Laipni lūdzam atlīdzības veikalā. Šeit varat izpirkt savus Bridgestone Plus punktus <br/> dažādu kategoriju balvām. Preču klāsts <br/> tiek regulāri atjaunināts. Mēs ceram, ka jums patiks pārlūkošana.",
  sort: {
    asc: "Kārtot pēc: Zemākā cena",
    desc: "Kārtot pēc: Augstākā cena",
  },
  productSearchBox: {
    from: "punkti no",
    to: "punkti līdz",
  },
  noProducts: "Meklēšanas kritēriji nedeva rezultātus",
  quantity: "Daudzums",
  search: "Meklēt",
  perPage: "Vienumi lapā",
  timeUnavailable: "Pašlaik nav pieejams",
  product: "Produkts",
  cart: {
    pointsPerUnit: "Punkti par vienību",
    pointsSum: "Punktu summa",
  },
  action: "Darbība",
  pointsTotal: "Kopā",
  cartRemainPoints: "Atlikušie punkti grozā",
  shoppingCart: "Iepirkumu grozs",
  emptyCart: "Iepirkumu grozs ir tukšs.",
  attributes: "Atribūti",
  selectAddressP: "Lūdzu, izvēlieties piegādes adresi",
  orderDelivery: "Piegādes adrese",
  selectedProducts: "Atlasītie produkti",
  orderSummary: "Pasūtījuma pārskats",
  contactPerson: "Kontaktpersona",
  selectedAddress: "Atlasītā adrese",
  order: {
    success: "Paldies! Jūsu pasūtījums bija veiksmīgs. Pēc dažām minūtēm saņemsiet pasūtījuma apstiprinājumu savā iesūtnē.",
    description: "Šeit atradīsiet pārskatu par saviem apbalvojumu veikala pasūtījumiem.",
    info: "Šeit atradīsiet pārskatu par saviem apbalvojumu veikala pasūtījumiem.",
    date: "Pasūtījuma datums",
    number: "Pasūtījuma nr.",
    status: {
      created: "Izveidots",
      confirm_order: "Apstiprināt pasūtījumu",
      ready_for_shipment: "Gatavs nosūtīšanai",
      rejected: "Noraidīts",
      processed: "Apstrādāts",
      shipped: "Nosūtīts",
      returned: "Atgriezts",
      finished: "Pabeigts",
    },
    anyOrder: "Nav pasūtījumu",
    products: "Produkti",
    quantity_short: "gab.",
    itemRemoved: "nevar piegādāt",
  },
  orders: "Pasūtījumi",
  notEnoughPoints: "Nav pietiekami pieejamo punktu.",
  statusText: "Statuss",
  outOfStock: "Pašlaik nav noliktavā",
  productUnavailable: "Šis produkts vairs nav pieejams.",
  deletedProductsTitle: "Produkti vairs nav pieejami",
  deletedProductsMessage: "Šie produkti vairs nav pieejami. Noņemiet tos no groza, lai turpinātu.",
  removeSelected: "Noņemt atlasītos",
  clearCart: "Izvest grozu",
  removeSelectedConfirm: "Noņemt atlasītos produktus no groza?",
  clearCartConfirm: "Noņemt visus produktus no groza?",
  incompleteAddress: {
    firstName: "Lūdzu, pievienojiet vārdu piegādes adresei",
    lastName: "Lūdzu, pievienojiet uzvārdu piegādes adresei",
    company: "Lūdzu, pievienojiet uzņēmuma nosaukumu piegādes adresei",
    street: "Lūdzu, pievienojiet ielu un mājas numuru piegādes adresei",
    postalCode: "Lūdzu, pievienojiet pasta indeksu piegādes adresei",
    city: "Lūdzu, pievienojiet pilsētu piegādes adresei",
    country: "Lūdzu, pievienojiet valsti piegādes adresei",
    phone: "Lūdzu, pievienojiet tālruņa numuru piegādes adresei",
  },
  placeOrder: "Saistošs pasūtījums",
  toOrderDelivery: "Turpināt uz piegādes adresi",
  toOrderSummary: "Uz pasūtījuma pārskatu",
  productImg: "Produkta attēls",
  selectAddressBtn: "Izvēlēties adresi",
  perPgae: "Vienumi lapā",
  categories: {
    advertising: {
      title: "Reklāmas materiāli",
      desc: "Piedalieties tieši šeit platformā un nodrošiniet <br/> 40 papildu punktus atlīdzību klubam.",
    },
    rewards: {
      title: "Ekskluzīvas atlīdzības",
      desc: "Atklājiet bonusa piedāvājumu mūsu mācību centrā vai savā atrašanās vietā.",
    },
    tools: {
      title: "Darbnīcas rīki",
      desc: "Izmantojiet punktus trešo pušu apmācībām <br/> un samaziniet izmaksas.",
    },
    trainings: {
      title: "Apmācības un kursi",
      desc: "Atklājiet bonusa piedāvājumu mūsu mācību centrā vai savā atrašanās vietā.",
    },
    salesroom: {
      title: "Pārdošanas telpa",
      desc: "Noformējiet pārdošanas telpu un piedāvājiet klientiem patīkamu uzturēšanos.",
    },
    hunter: {
      title: "Hunter",
      desc: "Mainiet punktus pret pievilcīgu Hunter darbnīcas aprīkojumu.",
    },
  },
  bestSold: "Visvairāk pārdotie",
  seasonal: "Sezonāls",
  affordable: "Gandrīz gatavs",
  forPoints: "par {points} punktiem",
  reachedPoints: "Nepieciešamie punkti sasniegti",
  remainingPoints: "Trūkst {points} punktu",
  favoriteProducts: {
    description: "Šeit atradīsiet saglabātos produktus.",
  },
  categoryPageDescriptionFallback: "Materiāli darbnīcai vai citi kvalitatīvi produkti ar Bridgestone logotipu jūsu uzņēmumam",
  variant: "Izvēlamie varianti",
};
export default {
  messages,
};
